// дескрипторы финансов
export const Finance = {
    id: 'finance',
    api: 'defBridge',
    title: 'Основные Расходы',
    showCheckboxes: false,
    pdf: true,
    items: [
        { id: 'nameFinance', title: 'Наименование расходов' },
        { id: 'size', title: 'Размер изделия' },
        { id: 'costFinance', title: 'Стоимость расходов' },
        { id: 'monthCost', title: 'Ежемесячный платёж' },
        { id: 'oneCost', title: 'Разовый платёж' },
        { id: 'summ', title: 'Итого' },
    ]
}

export const AddFinance = {
    id: 'addFinance',
    api: 'defBridge',
    title: 'Добавить расходы',
    showCheckboxes: false,
    pdf: true,
    items: [
        { id: 'nameFinance', title: 'Наименование расходов' },
        { id: 'size', title: 'Размер изделия (если есть необходимость)' },
        { id: 'costFinance', title: 'Стоимость расходов (₽)' },
        { id: 'monthCost', title: 'Ежемесячный платёж' },
        { id: 'oneCost', title: 'Разовый платёж' },
    ]
}